const ScrollText = () => {
  return (
    <div className="text-white py-6 md:py-8 w-full bg-blue-06 scrolling-container">
      {Array(6)
        .fill(0)
        .map((_, index) => (
          <h3 key={index} className="scrolling-text">
            <a href="/form" target="_blank" rel="noopener noreferrer">
              Get Exclusive Limited Time Period Discounts - Unlock Now!
            </a>
          </h3>
        ))}
    </div>
  );
};

export default ScrollText;
